import { gql } from '@apollo/client';

export default gql`
  query adminLocations {
    adminLocations {
      id
      name
    }
  }
`;
